import { Brain, Users, ListChecks, MessageSquareText } from "lucide-react";

export const SECTION_META = {
  personality: { label: "Personality & work style", icon: Brain, hint: "Validated research questionnaire. Every statement can be reworded or removed.", weightKey: "personality" },
  scenarios: { label: "Workplace Scenarios", icon: Users, hint: "Short situations with four ways to respond. Written for each job from its description.", weightKey: "scenarios" },
  quiz: { label: "Skills Quiz", icon: ListChecks, hint: "Your own questions with right answers. Scored automatically.", weightKey: "quiz" },
  custom: { label: "Custom questions", icon: MessageSquareText, hint: "Open or yes/no questions. Mark a question as scored or just for information.", weightKey: "quiz" },
};

export const QKINDS = { single: "One correct answer", multi: "Several correct answers", short: "Short answer", yesno: "Yes / No", text: "Long answer" };

export const INSTRUMENTS = {
  ipip_neo_120_safe: "Full work-style questionnaire (120 statements, hiring-safe)",
  ipip_50: "Short work-style questionnaire (50 statements)",
};

const rid = () => Math.random().toString(36).slice(2, 10);

export const newQuestion = (kind = "single") => ({
  id: rid(), kind, prompt: "", points: 1, scored: kind !== "text", required: false, model_answer: "", rubric: {}, competency: "",
  options: kind === "yesno" ? [{ id: "yes", text: "Yes", correct: true }, { id: "no", text: "No", correct: false }]
    : ["single", "multi"].includes(kind) ? [{ id: rid(), text: "", correct: false }, { id: rid(), text: "", correct: false }] : [],
});

export const newSection = (type) => ({
  id: rid(), type, title: SECTION_META[type].label, instrument: type === "personality" ? "ipip_neo_120_safe" : null,
  scenarios: [], questions: ["quiz", "custom"].includes(type) ? [newQuestion(type === "quiz" ? "single" : "text")] : [],
});

export const blankTemplate = () => ({
  name: "", description: "", time_limit_min: null, expiry_days: null,
  sections: [{ ...newSection("custom"), title: "HR and Judgment" }, newSection("scenarios"), newSection("quiz"), { ...newSection("custom"), title: "Problem-based Questions" }],
  weights: { personality: 0, scenarios: 50, quiz: 50 },
});

const ITEMS = { ipip_neo_120_safe: 124, ipip_50: 57 };
const SECS = { single: 40, multi: 50, yesno: 15, short: 180, text: 120 };

export function estimateMinutes(sections) {
  let s = 60;
  sections.forEach((x) => {
    if (x.type === "personality") s += (ITEMS[x.instrument] || 0) * 8;
    else if (x.type === "scenarios") s += (x.scenarios.length || 8) * 75;
    else s += x.questions.reduce((a, q) => a + SECS[q.kind], 0);
  });
  return Math.max(1, Math.round(s / 60));
}

export const usedWeights = (sections) => {
  const t = new Set(sections.map((s) => s.type));
  return { personality: t.has("personality"), scenarios: t.has("scenarios"), quiz: t.has("quiz") || t.has("custom") };
};

export const STATUS_STYLE = {
  published: ["Ready to use", "bg-success-tint text-success border-[#CADBCF]"],
  draft: ["Needs fixes", "bg-caution-tint text-caution border-[#E8D7B0]"],
  archived: ["Archived", "bg-surface-2 text-ink-muted border-line"],
};
